export default __webpack_public_path__ + "files/1_1_1_Characterization_questionnaire.docx";